import React from 'react';

import { CloseButton, PopoverHeader, Title } from './PopoverCard.styled';

export interface PopoverCardProps {
  setVisible?: (visibility: boolean) => void;
  noHeader?: boolean;
  title: string;
  children: React.ReactNode;
}

export function PopoverCard({ setVisible, children, title, noHeader = false }: PopoverCardProps) {
  const handleClose = () => {
    setVisible(false);
  };

  return (
    <>
      {!noHeader && (
        <>
          <PopoverHeader>
            <Title>{title}</Title>
            <CloseButton onClick={handleClose} />
          </PopoverHeader>
        </>
      )}
      {children}
    </>
  );
}
